import { render, staticRenderFns } from "./logisticsStar.vue?vue&type=template&id=2fabbcf8&scoped=true&"
import script from "./logisticsStar.vue?vue&type=script&lang=js&"
export * from "./logisticsStar.vue?vue&type=script&lang=js&"
import style0 from "./logisticsStar.vue?vue&type=style&index=0&id=2fabbcf8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fabbcf8",
  null
  
)

export default component.exports